import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchReclamationTransporteur } from 'store/reclamation/reclamationsActions';
import DetailsComplementairesRapidoTransportContent from './DetailsComplementairesRapidoTransportContent';
import withLoader from 'components/Shared/withLoader';

const DetailsComplementairesRapidoTransportContentWithLoader = withLoader(DetailsComplementairesRapidoTransportContent);

class DetailsComplementairesRapidoTransportContentContainer extends React.Component {

    componentDidMount() {
        this.props.fetchReclamationTransporteur(this.props.reclamationId);
    }

    render() {
        const { isLoading, onChange, transporteurId } = this.props;

        return (
            <DetailsComplementairesRapidoTransportContentWithLoader
                isLoading={isLoading}
                onChange={onChange}
                transporteurId={transporteurId}
            />
        );
    }
}

DetailsComplementairesRapidoTransportContentContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    reclamationId: PropTypes.number.isRequired
};

const mapStateToProps = (state, props) => {
    let transporteur = state.reclamation.reclamations.transporteurs.items.find(x => x.reclamationId === props.reclamationId);
    let isLoading = state.reclamation.reclamations.transporteurs.isLoading;
    

    return {
        isLoading: isLoading,
        transporteurId: transporteur ? transporteur.transporteurId : -1
    };
};

const mapDispatchToProps = dispatch => ({
    fetchReclamationTransporteur: (reclamationId) => dispatch(fetchReclamationTransporteur(reclamationId))
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailsComplementairesRapidoTransportContentContainer);